export default "__VITE_ASSET__B$myCzz4__"